import { FC, Suspense } from 'react'

import { useParams } from '@tanstack/react-router'

import { Skeleton } from '@forto-dev/phoenix-ui-core'

import { NotificationDetails } from './list/details'

export const Notification: FC = () => {
  const { id } = useParams({
    from: '/notification-center/$id',
  })

  return (
    <Suspense fallback={<Skeleton variant="card" />}>
      <NotificationDetails id={id} />
    </Suspense>
  )
}
